import { Typography } from '@material-ui/core';

/**
 * @param {import('@material-ui/core').TypographyProps} props
 */
const InputTitle = (props) => (
    <Typography
        component="p"
        className="input-label"
        {...props}
    >
        {props.children}
    </Typography>
);

export default InputTitle;
